module.exports = {
	"id": "MH",
	"name": "Marshall Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.033114,
			"12": null,
			"13": 0.027595,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.005519,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.005519,
			"27": null,
			"28": 0.022076,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.005519,
			"35": 0.044152,
			"36": 0.005519,
			"37": null,
			"38": 0.005519,
			"39": 0.066228,
			"40": null,
			"41": 0.033114,
			"42": null,
			"43": 0.071747,
			"44": 0.022076,
			"45": 0.022076,
			"46": 0.204203,
			"47": 0.082785,
			"48": 0.093823,
			"49": 3.3114,
			"50": 0.033114,
			"51": 0.965825,
			"52": 0.176608,
			"53": 23.643396,
			"54": 6.959459,
			"55": 0.16557,
			"56": 0.033114,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.005519,
			"4": null,
			"5": null,
			"6": 0.143494,
			"7": null,
			"8": 0.016557,
			"9": null,
			"10": null,
			"11": 0.016557,
			"12": null,
			"13": 0.016557,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.016557,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.005519,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.022076,
			"37": 0.005519,
			"38": 0.044152,
			"39": null,
			"40": null,
			"41": 0.11038,
			"42": 0.005519,
			"43": 0.121418,
			"44": 0.060709,
			"45": null,
			"46": 0.016557,
			"47": 0.132456,
			"48": 0.347697,
			"49": 4.542137,
			"50": 0.270431,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.033114
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005519,
			"29": 0.011038,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.005519,
			"37": 0.104861,
			"38": null,
			"39": null,
			"40": 0.137975,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.16557,
			"6": null,
			"7": 0.016557,
			"8": 0.044152,
			"9": 0.082785,
			"10": 1.457016,
			"3.1": null,
			"3.2": null,
			"5.1": 0.16557,
			"6.1": 0.082785,
			"7.1": null,
			"9.1": 0.463596
		},
		"ios_saf": {
			"8": 0,
			"10": 8.50037491674,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.229075268006,
			"8.1-8.4": 0.423206851062,
			"9.0-9.2": 0.201896846378,
			"9.3": 3.08022111782
		},
		"android": {
			"3": 0,
			"4": 0.126035361757,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0157544202196,
			"4.1": 0.45462755491,
			"4.2-4.3": 1.13656888727,
			"4.4": 2.60623123062,
			"4.4.3-4.4.4": 2.62873754522
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.0222228470067,
			"9": 0.116669946785,
			"10": 0.155559929047,
			"11": 2.21117327716,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0135969509849,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000377693082913
		},
		"edge": {
			"12": 1.1038,
			"13": 1.60051,
			"14": 1.070686
		},
		"ie_mob": {
			"10": 0.359616028169,
			"11": 1.46415097183
		},
		"bb": {
			"7": 0.00784175,
			"10": null
		},
		"samsung": {
			"0": 1.88202
		},
		"and_uc": {
			"0": 0.560125
		},
		"op_mini": {
			"0": 0.183189355932
		},
		"and_chr": {
			"0": 24.374051
		},
		"and_ff": {
			"0": 0.013443
		}
	},
	"total": 99.25670175
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MH.json
 ** module id = 587
 ** module chunks = 0
 **/